import { defaultLocale } from '@quno/onboarding/src/constants/locales';
import { FunnelCalendarBooking } from '@quno/patient-journey/src/components/CalendarBooking/FunnelCalendarBooking';
import type { Calendar as CalendarType } from '@quno/onboarding/src/generator/types/Models';
import type { FormLocales } from '@quno/patient-journey/src/constants/locales';
import type { Packages } from '@quno/patient-journey/src/contentful/generated/graphql';

export type Package = Omit<Packages, 'sys'> & {
  sys: { id: string };
};

type CalendarProps = CalendarType & {
  locale: FormLocales;
};

export const Calendar = (props: CalendarProps): JSX.Element => {
  const { attributes } = props ?? {};
  const { eventSetup, funnel, product } = attributes ?? {};

  const eventSetupId = eventSetup?.[defaultLocale] || '';
  const funnelId = funnel?.[defaultLocale] || '';

  const contentfulPackage = product?.[defaultLocale]
    ? {
        sys: { id: product[defaultLocale] },
      }
    : undefined;

  const titleOverride = attributes?.titleOverride?.[defaultLocale] || '';
  const hideDoctors = attributes?.hideDoctors?.[defaultLocale];

  return (
    <FunnelCalendarBooking
      eventSetupId={eventSetupId}
      funnelId={funnelId}
      contentfulPackage={contentfulPackage as Package}
      titleOverride={titleOverride}
      hideDoctors={hideDoctors}
    />
  );
};
